import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
import { initMetaPixel, initEngagementTracking } from './utils/metaPixel';
import { initSecurityProtection } from './utils/securityProtection';
function Root() {
  useEffect(() => {
    // Initialize Meta Pixel on mount
    initMetaPixel();
    // Initialize engagement tracking (scroll, time on page)
    initEngagementTracking();
    // Initialize security protection (anti-inspect for production)
    initSecurityProtection();
  }, []);
  return <App data-id="element-369" data-mp="2f85tvy8o6udd" />;
}
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-370" data-mp="2k1gz5uxu3336">
    <Root data-id="element-371" data-mp="2ozsbqdfijrp3" />
  </React.StrictMode>);